import { CalendarOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import BaseErrorEcho from './BaseErrorEcho';

const NoDataMessageEcho = ({ dataType }: { dataType: string }) => {
  const location = useLocation();
  const isEarningsPage = location.pathname.includes('earnings');
  const description = isEarningsPage
    ? 'Once campaigns are live, it may take one to two days to start displaying daily earnings, depending on your timezone.'
    : '';

  return (
    <BaseErrorEcho
      icon={<CalendarOutlined className="text-[32px] leading-none" aria-hidden />}
      title={`No ${dataType} found for this period`}
      desc={description}
    />
  );
};

export default NoDataMessageEcho;
